import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=485127e4"
import script from "./UserDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDetail.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports